import React, { useEffect, useState } from 'react'
import { Button, Dropdown, DropdownItem, Icon, Popover } from 'gu-ui-kit'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import styles from 'components/Select/select.module.scss'

const Select = ({
  name,
  value: { value = '', label = '' } = {},
  values = [],
  onChange = () => {},
  buttonClass = '',
  buttonProps = {},
}) => {
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'selector-' + name,
  })
  const [currentValue, setCurrentValue] = useState(value)

  useEffect(() => {
    onChange(currentValue)
  }, [currentValue])

  return (
    <>
      <Button
        className={clsx(buttonClass, styles['select-button'], {
          [styles['select-button_opened']]: !!popoverState.isOpen,
        })}
        size={'m'}
        variant={'ghost'}
        grey
        type="button"
        endIcon={<Icon name={'arrow-down'} />}
        {...buttonProps}
        {...bindTrigger(popoverState)}
      >
        {label}
      </Button>
      <Popover
        {...bindPopover(popoverState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 2,
          horizontal: 'left',
        }}
        disablePortal={true}
        hideBackdrop={true}
      >
        <Dropdown onClick={() => popoverState.isOpen && popoverState.close()}>
          {values.map((item) => (
            <DropdownItem
              key={'selector-' + name + '-' + item.value}
              variant={'p8'}
              onClick={() => {
                setCurrentValue(item.value)
                popoverState.close()
              }}
            >
              {item.label}
            </DropdownItem>
          ))}
        </Dropdown>
      </Popover>
    </>
  )
}

Select.propTypes = {
  name: PropTypes.string,
  value: PropTypes.shape({ value: PropTypes.any, label: PropTypes.string }),
  values: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })),
  onChange: PropTypes.func,
  buttonClass: PropTypes.string,
}

export default Select

Select.propTypes = {
  name: PropTypes.string,
  value: PropTypes.object,
  values: PropTypes.array,
  onChange: PropTypes.func,
  buttonClass: PropTypes.string,
  buttonProps: PropTypes.object,
}
